import { useMemo } from "react";
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from "recharts";

export default function WareHouseGraph({ subtitle, title, dataSet }) {
  const parsedData = useMemo(
    () =>
      dataSet.map(item => ({
        ...item,
        min: Number(item.min),
        max: Number(item.max),
        endingBalance: Number(item.endingBalance),
        newEndingBalance: Number(item.newEndingBalance),
      })),
    [dataSet]
  );

  return (
    <div style={{ width: "100%" }}>
      {/* Title */}
      <div style={{ marginBottom: 8 }}>
        <h3 style={{ margin: 0, fontFamily: "Times New Roman,Times, serif" }}>{title}</h3>
        {subtitle && (
          <div
            style={{
              fontFamily: "Times New Roman,Times, serif",
              fontSize: 12,
              fontWeight: "bold",
              textAlign: "center",
              marginTop: 2,
              color: "#555",
            }}>
            {subtitle}
          </div>
        )}
      </div>

      {/* Chart */}
      <ResponsiveContainer width="100%" height={300}>
        <LineChart data={parsedData} margin={{ top: 10, right: 30, left: 0, bottom: 0 }}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="forecastDt" />
          <YAxis />
          <Tooltip />
          <Line type="monotone" dataKey="min" stroke="#ff0000" strokeWidth={2} dot={{ r: 4 }} activeDot={{ r: 6 }} />
          <Line type="monotone" dataKey="max" stroke="#00ff00" strokeWidth={2} dot={{ r: 4 }} activeDot={{ r: 6 }} />
          <Line
            type="monotone"
            dataKey="newEndingBalance"
            stroke="#0000ff"
            strokeWidth={2}
            dot={{ r: 4 }}
            activeDot={{ r: 6 }}
          />
          <Line
            type="monotone"
            dataKey="endingBalance"
            stroke="#000000"
            strokeWidth={2}
            dot={{ r: 4 }}
            activeDot={{ r: 6 }}
          />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
}
